import React from 'react'
import { Button } from '@material-ui/core'
import SummaryContainer from '../partials/SummaryContainer'
import OrganizationsTable from './OrganizationsTable'
import { observer } from 'mobx-react'
import { inject } from 'mobx-react'
import { flow } from 'lodash'
import { IStore } from '../../../../store/models'
import { IUser } from '../../../../store/models/User'
import { RouteComponentProps, withRouter } from 'react-router'

interface Props {
  user?: IUser
}

const OrganizationsSummary = ({ user, history }: Props & RouteComponentProps) => {
  return (
    <div>
      <SummaryContainer
        title='Organizations'
        topRight={
          user?.isSuperAdmin() ? (
            <Button onClick={() => history.push('/admin/organizations/new')} variant='contained' startIcon={<i className='far fa-plus-circle'></i>}>
              New Organization
            </Button>
          ) : undefined
        }
      >
        <OrganizationsTable />
      </SummaryContainer>
    </div>
  )
}

export default flow(
  withRouter,
  observer,
  inject<FIXME, FIXME>(
    ({
      mst: {
        auth: { user }
      }
    }: {
      mst: IStore
    }) => {
      return {
        user
      }
    }
  )
)(OrganizationsSummary)
